import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Llegando a la sesión sin un protocolo de encuadre que contenga al consultante desde el primer minuto', 'Dudando cómo leer el genograma porque no tenés una simbología clara ni plantillas listas para usar', 'Sin saber qué intervención usar cuando el campo se detiene y el consultante te mira esperando', 'Sin protocolo de seguimiento entre sesiones — cada consulta sin continuidad real', 'Sin frases sanadoras clasificadas por tipo de conflicto listas para usar cuando las necesitás', 'Sin ficha clínica profesional — procesos sin registro ni hilo conductor', 'Consultantes que no vuelven porque no perciben estructura ni profundidad en el proceso', 'Cada sesión empezás de cero, sin dirección real ni sistema clínico que te respalde'];
  return <Section className="max-w-4xl" data-id="element-309" data-mp="3ncxta5czo7p7">
      <div className="text-center mb-12" data-id="element-310" data-mp="3nbwi80vz3l7h">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold mb-6 leading-tight text-brand-violetDark" data-id="element-311" data-mp="1z0f2n3p1vmal">
          ¿Cuántas sesiones más vas a improvisar?
        </h2>
        <p className="text-brand-text/80 mb-4 text-sm md:text-base max-w-2xl mx-auto" data-id="element-312" data-mp="27sz389owk0y2">
          Sos terapeuta en Constelaciones Familiares. Amás lo que hacés. Pero
          nadie te dijo que ibas a llegar a la sesión sin saber exactamente qué
          registrar, sin un sistema para leer el genograma, sin un protocolo
          claro cuando el campo se detiene y sin una ficha clínica que sostenga
          la continuidad del proceso.
        </p>

        <p className="text-lg md:text-xl font-medium text-brand-burgundy mt-6 font-serif italic" data-id="element-313" data-mp="1p3aamn8iwwlv">
          No es falta de formación. Es falta de un sistema.
        </p>
      </div>

      <div className="glass-panel p-6 md:p-10 rounded-3xl mb-12 bg-white/70 border-brand-burgundy/20" data-id="element-314" data-mp="30guugyvpd0ng">
        <h3 className="font-serif font-bold mb-6 flex items-center text-brand-violetDark text-base md:text-lg" data-id="element-315" data-mp="2vhjehs35tz6x">
          <X className="w-6 h-6 text-brand-burgundy mr-2 shrink-0" data-id="element-316" data-mp="1t4deqwrc0y5o" /> Lo que
          pasa sin el Vademécum del Constelador Familiar™:
        </h3>
        <ul className="space-y-4" data-id="element-317" data-mp="225tor3e8iy9d">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-318" data-mp="223qozrna5qrg" data-mpi={i}>
              <X className="w-5 h-5 text-brand-burgundy/80 mr-3 mt-0.5 shrink-0" data-id="element-319" data-mp="27568hf9t7p7q" />
              <span className="text-brand-text/80 text-sm md:text-base" data-id="element-320" data-mp="1af73fusvb8tw">
                {point}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-321" data-mp="1edwdpeim0a9b">
        <h3 className="text-xl md:text-3xl font-display font-bold purple-gradient-text" data-id="element-322" data-mp="1jf3lveonzbgi">
          ¿Y si esta fuera la última sesión que trabajás así?
        </h3>
      </div>
    </Section>;
};